import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

export const getVenderEventLists = async (user, search) => {
  const storageAvailable = localStorageAvailable();
  const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
  const mode = localStorage.getItem('mode');

  const config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: '/system/partners',
    headers: {
      authorization: `Bearer ${accessToken}`,
      user,
      'Content-Type': 'application/json',
    },
    params: { type: 'Vendor', page: 0, pagination: false, search, mode },
  };
  try {
    const response = await axios.request(config);
    return response?.data;
  } catch (error) {
    console.error('Error fetching discount details:', error);
    throw error;
  }
};
